/*
  Designers: filtros da página de designers (por tipo de peça) e da página de cada designer
  (por categoria). Cada item traz data-dsg-tags com as etiquetas separadas por espaço;
  um grupo sem item visível some junto, e a contagem acompanha o filtro.
*/
(function () {
  function initFiltro(root) {
    const buttons = [...root.querySelectorAll('[data-dsg-filter]')];
    if (!buttons.length) return;

    const items = [...root.querySelectorAll('[data-dsg-item]')];
    const groups = [...root.querySelectorAll('[data-dsg-group]')];
    const count = root.querySelector('[data-dsg-count]');
    const empty = root.querySelector('[data-dsg-empty]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.dsgFilter;
        let visible = 0;

        buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        items.forEach((item) => {
          const tags = (item.dataset.dsgTags || '').split(' ');
          const show = !filter || tags.includes(filter);
          item.hidden = !show;
          if (show) visible += 1;
        });

        groups.forEach((group) => {
          group.hidden = !group.querySelector('[data-dsg-item]:not([hidden])');
        });

        if (count) {
          count.textContent = visible + ' ' + (visible === 1 ? count.dataset.um : count.dataset.varios);
        }
        if (empty) empty.hidden = visible > 0;
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-dsg-filtro]').forEach(initFiltro);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
